<template>
  <v-main>
    <AppBar :title="title" />
    <v-layout fill-height column>
      <v-container flex-fill fluid class="pa-0">
        <v-tabs v-model="tab" grow color="#000" slider-size="3" v-bind:disabled="isAuthCodeSend">
          <v-tab :ripple="false" v-bind:disabled="isAuthCodeSend">휴대전화 인증</v-tab>
          <v-tab :ripple="false" v-bind:disabled="isAuthCodeSend">이메일 인증</v-tab>
        </v-tabs>
        <div class="pa-5 pt-7">
          <v-tabs-items v-model="tab" touchless>
            <v-tab-item transition="false">
              <v-form class="form-item" ref="tab0" lazy-validation>
                <template v-if="this.division==='01'">
                  <label class="label">기업명</label>
                  <div class="input-group">
                    <v-text-field solo flat filled form-control required
                                  v-model="clientNm"
                                  autocomplete="off"
                                  v-bind:readonly="true"/>
                  </div>
                </template>

                <label class="label">아이디</label>
                <div class="input-group">
                  <v-text-field solo flat filled v-model="userId" required placeholder="아이디 입력" v-bind:readonly="isAuthCodeSend"/>
                </div>

                <label class="label">이름</label>
                <div class="input-group">
                  <v-text-field solo flat filled v-model="userName" required placeholder="이름 입력" v-bind:readonly="isAuthCodeSend"/>
                </div>

                <label class="label">휴대전화</label>
                <div class="input-group mb-3">
                  <v-text-field maxlength="11"
                                oninput="javascript: this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                                solo flat filled hide-details="true" v-model="phone" required placeholder="01012345678" v-bind:readonly="isAuthCodeSend"/>
                  <v-btn :ripple="false"
                        depressed
                        color="primary"
                        class="btn-input"
                        width="115px"
                        @click="checkMemberExist"
                        v-bind:disabled="sendBtnDisabled"
                  >{{ statusText }}
                  </v-btn>
                </div>

                <div class="input-group" v-show="memberExist===1">
                  <v-text-field solo flat filled
                                v-model="authCode"
                                required
                                maxlength="6"
                                placeholder="인증번호를 입력"
                                oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                                v-bind:readonly="isAuthCodeSuccess">
                    <template #append>
                      <Timer ref="timer" @timeLimit="timeLimit"/>
                    </template>
                  </v-text-field>
                  <v-btn :ripple="false"
                         depressed
                         color="primary"
                         class="btn-input"
                         width="115px"
                         v-bind:disabled="isBtnAt"
                         @click="checkAuthCode">확인
                  </v-btn>
                </div>
                <div class="px-3 mt-n2 mb-6" v-if="isBtnAt">
                  <span class="lightBlue--text fs-12" v-if="codeConfirm">{{codeChkReturnMsg}}</span>
                  <span class="error--text fs-12" v-else>{{codeChkReturnMsg}}</span>
                </div>
              </v-form>
            </v-tab-item>
            <v-tab-item transition="false">
              <v-form class="form-item" ref="tab1" lazy-validation>

                <template v-if="this.division==='01'">
                  <label class="label">기업명</label>
                  <div class="input-group">
                    <v-text-field solo flat filled form-control required
                                  v-model="clientNm"
                                  autocomplete="off"
                                  v-bind:readonly="true"/>
                  </div>
                </template>

                <label class="label">아이디</label>
                <div class="input-group">
                  <v-text-field solo flat filled v-model="userId" required placeholder="아이디 입력" v-bind:readonly="isAuthCodeSend"/>
                </div>

                <label class="label">이름</label>
                <div class="input-group">
                  <v-text-field solo flat filled v-model="userName" required placeholder="이름 입력" v-bind:readonly="isAuthCodeSend"/>
                </div>

                <label class="label">이메일</label>
                <div class="input-group">
                  <v-text-field solo flat filled v-model="email" :rules="email_rule" required
                                placeholder="welcome@eznwell.co.kr"/>
                  <v-btn :ripple="false"
                         depressed
                         color="primary"
                         class="btn-input"
                         width="115px"
                         @click="checkMemberExist"
                         v-bind:disabled="sendBtnDisabled"
                  >{{ statusText }}
                  </v-btn>
                </div>
                <div class="input-group" v-show="memberExist===1">
                  <v-text-field solo flat filled
                                v-model="authCode"
                                required
                                placeholder="인증번호를 입력"
                                maxlength="6"
                                type="number"
                                oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');">
                    <template #append>
                      <Timer ref="timer" @timeLimit="timeLimit"/>
                    </template>
                  </v-text-field>
                  <v-btn :ripple="false"
                         depressed
                         color="primary"
                         class="btn-input"
                         width="115px"
                         v-bind:disabled="isBtnAt"
                         @click="checkAuthCode">확인
                  </v-btn>
                </div>
                <div class="px-3 mt-n2 mb-6" v-if="isBtnAt">
                  <span class="lightBlue--text fs-12" v-if="codeConfirm">{{codeChkReturnMsg}}</span>
                  <span class="error--text fs-12" v-else>{{codeChkReturnMsg}}</span>
                </div>
              </v-form>
            </v-tab-item>
          </v-tabs-items>
        </div>

      </v-container>
      <div class="footer-btns">
        <BlackBtn x-large str="확인" v-bind:disabled="doNextChk=== -1" @click="goToPasswdChange"/>
      </div>
    </v-layout>
    <NotMatchSheet :sheet="sheet" ref="sheet" @sheetClose="sheet = false"/>
  </v-main>
</template>

<script>
import BlackBtn from "@/components/btns/BlackBtn"
import NotMatchSheet from "@/components/layout/bottomSheet/NotMatchSheet"
import Timer from "@/components/util/TimerAccount.vue"
import store from "@/store"

export default {
  data: () => ({
    title:'',
    tab: 0,
    valid: false,
    valid2: false,
    userId: '',
    userName: '',
    phone: '',
    authCode: '',
    sheet: false,
    email: '',
    sendOk: -1,
    authType: '',
    userKey: '',
    division: '',
    clientNm: '',
    selectItems: [],
    isInput: false,
    statusText: '인증번호 발송',
    memberExist: -1,
    clientNo: '',
    isTimeOut:false,  //인증시간종료
    isBtnAt :  false,   // 인증번호 확인버튼 disabled
    codeConfirm: false,
    isAuthCodeSend:false,
    isAuthCodeSuccess:false,
    codeChkReturnMsg:'',
    isClientSelect:false,
    sendBtnDisabled:true,
    doNextChk:-1,
    clientId:'',
  }),
  components: {
    BlackBtn,
    NotMatchSheet,
    Timer,
  },
  computed: {
    email_rule() {
      return [
        v => !!v || '이메일을 입력하지 않았습니다.',
        v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || '메일 형식이 잘못 되었습니다.',
      ]
    }
  },
  created() {
    // this.search();
  },
  mounted() {
    this.division = this.$route.params.division;
    if (this.division === "02") {
      this.clientNo = "b2c";
      this.title = "개인회원 비밀번호 재설정"
    }else if(this.division === "01") {
      this.title = "기업회원 비밀번호 재설정"
    }

    this.clientId = this.$route.query.clientId
    this.getClientInfo()
  },
  watch: {
    tab() {
      if (this.tab === 0) {
        this.$refs.tab1.reset()
        this.getClientInfo()
      } else {
        this.$refs.tab0.reset()
        this.getClientInfo()
      }
    },
    authCode : function(newVal, oldVal) {
			if(newVal !== oldVal && !this.isTimeOut) {
				this.isBtnAt = false;
			}
		},
    userId(){
      this.sendBtnChk()
    },
    userName(){
        this.sendBtnChk()
    },
    phone(){
        this.sendBtnChk()
    },
    email(){
        this.sendBtnChk()
    },
    // clientNm(){
    //   if(this.clientNm != null){
    //     if(this.clientNm !== '' && this.clientNm.length > 0) {
    //       if(this.selectItems.length == 0){
    //         this.search()
    //       }
    //     }

    //     if (this.clientNm !== '' && this.clientNm.length > 0 && !this.isClientSelect) {
    //       this.isInput = true
    //     }else{
    //       this.isInput = false
    //     }
    //   }
    // },
  },
  methods: {
    sendBtnChk(){
      var phoneMail = false // 휴대전화, 이메일 확인용

      if(this.tab === 0){
        if(this.phone != null){
          if(this.phone.length >= 10 && this.phone.length <= 11){
            phoneMail = true
          }else{
            phoneMail = false
          }
        }
      }else{
        if(this.email != null){
          if(this.email.length > 0){

            let validatetab1 = this.$refs.tab1.validate() //이메일주소 형식 검증

            if(validatetab1){
              phoneMail = true
            }else{
              phoneMail = false
            }
          }else{
            phoneMail = false
          }
        }
      }

      if(this.division==='01'){ // 기업회원
        if(this.clientNm != null && this.userId != null && this.userName != null){
          if(this.clientNm.trim() != '' && this.userId.trim() != '' && this.userName.trim() != '' && phoneMail){
            this.sendBtnDisabled = false
          }else{
            this.sendBtnDisabled = true
          }
        } else{
          this.sendBtnDisabled = true
        }
      }else if(this.division==='02'){ // 일반회원
        if(this.userId != null && this.userName != null){
          if(this.userId.trim() != '' && this.userName.trim() != '' && phoneMail){
            this.sendBtnDisabled = false
          }else{
            this.sendBtnDisabled = true
          }
        } else{
          this.sendBtnDisabled = true
        }
      }

    },
    touchDataSelected() {
      this.dataSelected()
    },
    dataSelected() {
      this.isClientSelect = true
    },
    // async search() {
    //   await store.dispatch('getClientSearch')
    //       .then(res => {
    //         if (res.success) {
    //           this.selectItems = res.data;

    //         } else {
    //           console.log("error");
    //           this.selectItems = [];

    //         }
    //       })
    //       .catch(error => {
    //         console.error(error);
    //         this.selectItems = [];
    //       })
    //       .finally(() => {
    //       })
    // },
    // clientSearch() {
    //   if (this.clientNm !== '' && this.clientNm.length > 0) {
    //     this.isInput = true;
    //     //this.search();
    //   }
    // },
    async getClientInfo() {
      await store.dispatch('getClientInfo',this.$_payload({'clientNo': this.clientId}))
          .then(res => {

            if (res.success) {
              this.clientNm = res.data.clientNm;
              // this.isInput = true

            } else {
              console.log("error");
              this.selectItems = [];

            }
          })
          .catch(error => {
            console.error(error);
            this.selectItems = [];
          })
          .finally(() => {
          })
    },
    goToPasswdChange() {
      this.$router.push({name: "비밀번호 재설정", params: {userKey: this.userKey}});
    }

    /* 인증번호 확인 */
    ,async doSendAuthCode() {

      //성공
      // this.doSendChk = 1;
      // this.statusText = '인증번호 재발송';
      // this.isBtnAt = false
      // this.isAuthCodeSend = true  // 정보수정불가
      // this.isAuthCodeSuccess = false  //인증번호 확인 초기화
      // this.isTimeOut = false
      // this.doNextChk = -1;  // 다음버튼 초기화
      // this.$refs.timer.timerStop()
      // this.$refs.timer.timerStart();
      // this.authCode = ''      // 코드값 초기화
      // this.codeConfirm = false;

      let inParam;
      if (this.tab === 0) {
        inParam = {
          authType: "phone",
          phone: this.phone
        };
      } else if (this.tab === 1) {
        inParam = {
          authType: "email",
          email: this.email
        };
      }

      await store.dispatch('generateSetAuthCode', this.$_payload(null, inParam))
          .then(res => {
            if (res.success) {
              this.doSendChk = 1;
              this.statusText = '인증번호 재발송';
              this.isBtnAt = false
              this.isAuthCodeSend = true  // 정보수정불가
              this.isAuthCodeSuccess = false  //인증번호 확인 초기화
              this.isTimeOut = false
              this.doNextChk = -1;  // 다음버튼 초기화
              this.$refs.timer.timerStop()
              this.$refs.timer.timerStart();
              this.authCode = ''      // 코드값 초기화
              this.codeConfirm = false;
            }
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {
          })
    },


    async checkMemberExist() {

       //성공
      // this.doSendAuthCode();
      // this.memberExist = 1;

      //실패
      // this.sheet = true;

      let query;
      if (this.tab === 0) { //휴대전화 인증

        if (this.division === '02') { //일반회원
          query = {
            userId: this.userId,
            userName: this.userName,
            clientNm: '',
            clientNo: this.clientNo,
            mobileNo: this.phone,
            authType: 'phone'
          };
        } else if (this.division === '01') { //기업회원
          query = {
            userId: this.userId,
            userName: this.userName,
            clientNm: this.clientNm,
            mobileNo: this.phone,
            authType: 'phone'
          };
        }
      } else if (this.tab === 1) { //이메일 인증

        if (this.division === '02') { //일반회원
          query = {
            userId: this.userId,
            userName: this.userName,
            clientNm: '',
            clientNo: this.clientNo,
            email: this.email,
            authType: 'email'
          };
        } else if (this.division === '01') { //기업회원
          query = {
            userId: this.userId,
            userName: this.userName,
            clientNm: this.clientNm,
            email: this.email,
            authType: 'email'
          };
        }
      }

      /*
      * 선행조건 > 기본 입력 정보로 회원 존재 유무 판단.
      */
      await store.dispatch('checkMemberExist', this.$_payload("param", query))
          .then(res => {
              if (res.success) {

                if(res.data > 0) {

                  this.doSendAuthCode();
                  this.memberExist = 1;
                  this.userKey = res.data;

                } else {
                  this.sheet = true;
                }
              }
          }).catch(error => {
            console.error(error)
          }).finally(() => {})
    },

    /* 인증코드 확인 */
    async checkAuthCode() {

      //성공
      // this.isBtnAt = true
      // this.doNextChk = 1;
      // this.codeConfirm = true;
      // this.isAuthCodeSuccess = true
      // this.doSendChk = -1;
      // this.$refs.timer.timerStop();
      // this.codeChkReturnMsg = '인증되었습니다.'
      // this.isBtnAt = true

      //실패
      // this.isBtnAt = true
      // this.codeChkReturnMsg = '인증 번호를 확인해주세요.'
      // this.doSendChk = 1;

      let outParam;
      if (this.tab === 0) {
        outParam = {
          phone: this.phone,
          authCode: this.authCode,
          authType: 'phone'
        };
      } else {
        outParam = {
          email: this.email,
          authCode: this.authCode,
          authType: 'email'
        };
      }

      await store.dispatch('checkAuthCode', this.$_payload("param", outParam))
          .then(res => {
            if (res.success) {
              this.isBtnAt = true
              this.doNextChk = 1;
              this.codeConfirm = true;
              this.isAuthCodeSuccess = true
              this.doSendChk = -1;
              this.$refs.timer.timerStop();
              this.codeChkReturnMsg = '인증되었습니다.'
              this.isBtnAt = true

            } else {

              this.isBtnAt = true
              this.codeChkReturnMsg = '인증 번호를 확인해주세요.'
              this.doSendChk = 1;
            }
          }).catch(error => {
            console.error(error)
          }).finally(() => {
          })
    },
    timeLimit(){
      this.isAuthCodeSend = false  //인증 실패시 수정가능
      this.isTimeOut = true
      this.doNextChk = -1;
      this.codeConfirm = false
      this.isBtnAt = true
      this.codeChkReturnMsg = '인증번호 입력 시간이 지났습니다. 다시 진행해주세요.'
    }
  }
}
</script>
<style lang="scss" scoped>
.v-tabs::v-deep {
  border-bottom: 1px solid $color-gray-3;

  .v-tab {
    font-size: 18px;
    font-weight: 400;
    color: #BDC3CA !important;

    &.v-tab--active {
      color: #212529 !important;
    }
  }
}

.pos-relative {
  flex: 1 1 auto;
}

.v-input::v-deep {
  .v-text-field__details {
    padding-left: 0;
  }
}

.time {
  position: absolute;
  right: 8px;
  top: 14px;
  color: $color-red;
  font-size: 14px;
}
</style>
